(function () {
  if (window.PremiumAddToCartSuccessInitialized) return;
  window.PremiumAddToCartSuccessInitialized = true;

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    const pendingVariantIds = new Set();

    // Record which variant is being submitted, without touching product-form.js.
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput) pendingVariantIds.add(String(variantInput.value));
      },
      true
    );

    // product-form.js publishes this only on a genuine successful add.
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form') return;
      const variantId = String(event.productVariantId);
      if (!pendingVariantIds.has(variantId)) return;
      pendingVariantIds.delete(variantId);

      document.querySelectorAll('.premium-buy-buttons__add-to-cart').forEach((button) => {
        const form = button.closest('product-form');
        const currentVariantInput = form?.querySelector('[name="id"]');
        if (!currentVariantInput || currentVariantInput.value !== variantId) return;

        button.classList.add('is-added');
        window.clearTimeout(button._premiumAddedTimeout);
        button._premiumAddedTimeout = window.setTimeout(() => {
          button.classList.remove('is-added');
        }, 1200);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();